import range from "lodash/range";
import { remRhythm, rem, getElevation, generateColorScale } from "./css"; // Fonts

export var TEXT_FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
export var HEADING_FONT = "MetaWeb, " + TEXT_FONT; // Colors

export var BLUE = "#2f8aac";
export var BLUES = generateColorScale(BLUE);
export var GREEN = "#00866b";
export var GREENS = generateColorScale(GREEN);
export var RED = "#d22a15";
export var REDS = generateColorScale(RED);
export var ORANGE = "#d1892a";
export var ORANGES = generateColorScale(ORANGE);
export var CHARCOAL = "#8c8980";
export var CHARCOALS = generateColorScale(CHARCOAL);
export var GRAY = "#999";
export var GRAYS = generateColorScale(GRAY);
export var BACKGROUND_COLOR = "#f7f7f7";
export var BORDER_COLOR = GRAYS[100];
export var RULE_COLOR = GRAYS[200];
export var MUTED_COLOR = GRAY;
export var TEXT_COLOR = CHARCOALS[800];
export var HEADING_COLOR = CHARCOALS[900];
export var INFO_COLOR = BLUE;
export var SUCCESS_COLOR = GREEN;
export var WARNING_COLOR = ORANGE;
export var ERROR_COLOR = RED;
export var WHITE = "#fff";
export var BLACK = "#000"; // Legacy Colors

export var LEGACY_CHARCOAL = "#2e2c26";
export var LEGACY_CHARCOAL_GRAY = "#57554f";
export var LEGACY_TEXT_COLOR = LEGACY_CHARCOAL_GRAY;
export var LEGACY_HEADING_COLOR = LEGACY_CHARCOAL;
export var LEGACY_BACKGROUND_COLOR = "#f0efed";
export var LEGACY_BORDER_COLOR = "#d8d8d8"; // Z-Indexes

export var DROPDOWN_Z_INDEX = 1000;
export var STICKY_Z_INDEX = 1100;
export var FIXED_Z_INDEX = 1200;
export var MODAL_OVERLAY_Z_INDEX = 1290;
export var MODAL_Z_INDEX = 1300;
export var POPOVER_Z_INDEX = 1400;
export var TOOLTIP_Z_INDEX = 1500;
export var TOAST_Z_INDEX = 1600;
var breakpoints = ["480px", "600px", "800px"];
breakpoints.xs = "320px";
breakpoints.sm = "480px";
breakpoints.md = "600px";
breakpoints.lg = "800px";
breakpoints.xl = "1280px";
breakpoints.xxl = "1600px";
var theme = {
  breakpoints: breakpoints,
  radii: {
    sm: "2px",
    md: "4px",
    lg: "8px"
  },
  fonts: {
    text: TEXT_FONT,
    heading: HEADING_FONT
  },
  fontSizes: {
    xxs: rem(11),
    xs: rem(13),
    sm: rem(14),
    md: rem(16),
    lg: rem(20),
    xl: rem(26),
    xxl: rem(32)
  },
  lineHeights: {
    solid: "1em",
    heading: "1.25em",
    text: "1.5em"
  },
  fontWeights: {
    normal: 300,
    bold: 700
  },
  space: {
    // Backwards compatibility with array index access
    "0": 0,
    "1": remRhythm(1 / 8),
    "2": remRhythm(1 / 4),
    "3": remRhythm(1 / 2),
    "4": remRhythm(1),
    "5": remRhythm(1 + 1 / 2),
    "6": remRhythm(2),
    "7": remRhythm(3),
    "8": remRhythm(4),
    // Preferred way of accessing spacing values
    none: 0,
    xxs: remRhythm(1 / 8),
    xs: remRhythm(1 / 4),
    sm: remRhythm(1 / 2),
    md: remRhythm(1),
    lg: remRhythm(1 + 1 / 2),
    xl: remRhythm(2),
    xxl: remRhythm(3),
    xxxl: remRhythm(4)
  },
  elevations: range(25).map(getElevation),
  colors: {
    blue: BLUE,
    blues: BLUES,
    green: GREEN,
    greens: GREENS,
    red: RED,
    reds: REDS,
    orange: ORANGE,
    oranges: ORANGES,
    charcoal: CHARCOAL,
    charcoals: CHARCOALS,
    gray: GRAY,
    grays: GRAYS,
    white: WHITE,
    black: BLACK,
    // UI Colors
    background: BACKGROUND_COLOR,
    border: BORDER_COLOR,
    rule: RULE_COLOR,
    muted: MUTED_COLOR,
    text: TEXT_COLOR,
    heading: HEADING_COLOR,
    info: INFO_COLOR,
    success: SUCCESS_COLOR,
    warning: WARNING_COLOR,
    error: ERROR_COLOR,
    // Legacy Colors
    legacyCharcoal: LEGACY_CHARCOAL,
    legacyCharcoalGray: LEGACY_CHARCOAL_GRAY,
    legacyText: LEGACY_TEXT_COLOR,
    legacyHeading: LEGACY_HEADING_COLOR,
    legacyBackground: LEGACY_BACKGROUND_COLOR,
    legacyBorder: LEGACY_BORDER_COLOR
  },
  zIndices: {
    dropdown: DROPDOWN_Z_INDEX,
    sticky: STICKY_Z_INDEX,
    fixed: FIXED_Z_INDEX,
    modalOverlay: MODAL_OVERLAY_Z_INDEX,
    modal: MODAL_Z_INDEX,
    popover: POPOVER_Z_INDEX,
    tooltip: TOOLTIP_Z_INDEX,
    toast: TOAST_Z_INDEX
  }
};
export default theme;